import React from "react";


function TextHM({prop}) {
    return (
            <div className='centered'>
                <div className='banner-text'>
                <h1>{prop}</h1>
                </div>
            </div>
    );
}

export default React.memo(TextHM);